import { getSpecificParent } from './getSpecificParent';

/**
 * Permite iterar desde un elemento hacia arriba en el
 * DOM, utilizando una función de comparación para
 * determinar si el elemento actual es el que estamos
 * buscando.
 *
 * Si la función checkParent devuelve true, isChild
 * devuelve true.
 */
export function isChild(
  element: HTMLElement | null,
  checkParent: (parent: HTMLElement) => boolean | null,
) {
  return !!getSpecificParent(element, checkParent);
}
